import { parse } from "./lucene-query-parser";
import { ParseNode } from "./lucene-query-parser-types";

export const parseQuery = (input: string, translation?: (x: string) => string): ParseNode => {
    try {
        return parse(input, {});
    } catch (e: unknown) {
        const errorMessage = e instanceof Error ? e.message : String(e);
        if (!translation) throw errorMessage;
        const expected = translation("shared.Expected");
        const endOfInput = translation("shared.end of input");
        const found = translation("shared.found");
        const whitespace = translation("shared.whitespace");
        const or = translation("shared.or");
        const but = translation("shared.but");
        const anyCharacter = translation("shared.any character");

        throw `${errorMessage
            ?.replace("Expected", expected)
            ?.replace("end of input", endOfInput)
            ?.replace("found", found)
            ?.replace("whitespace", whitespace)
            ?.replace("or", or)
            ?.replace("but", but)
            ?.replace("any character", anyCharacter)}`;
    }
};

export const queryIsValid = (input: string) => {
    try {
        parseQuery(input);
        return true;
    } catch {
        return false;
    }
};
